export default {
    path: '/order_types',
    name: 'order_types',
    component: () => import('../components/ordertype/Layout'),
    redirect: {name: 'OrderTypeList'},
    meta: {
        breadcrumb: 'order.types',
    },
    children: [
        {
            name: 'OrderTypeList',
            path: '',
            component: () => import('../views/ordertype/List'),
            meta: {
                breadcrumb: 'global.list',
            },
        },
        {
            name: 'OrderTypeCreate',
            path: 'new',
            component: () => import('../views/ordertype/Create'),
            meta: {
                breadcrumb: 'global.add',
            },
        },
        {
            name: 'OrderTypeUpdate',
            path: ':id/edit',
            component: () => import('../views/ordertype/Update'),
            meta: {
                breadcrumb: 'order.type',
            },
        },
        {
            name: 'OrderTypeShow',
            path: ':id',
            component: () => import('../views/ordertype/Show'),
            meta: {
                breadcrumb: 'order.type',
            },
        }
    ]
};